module.exports = __webpack_public_path__ + "img/motive-2.b3b611db.jpg";